import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["header", "body"];

  sort(event) {
    const th = event.currentTarget;
    const index = Array.from(th.parentElement.children).indexOf(th);
    const type = th.dataset.sortType || "string";
    const rows = Array.from(this.bodyTarget.querySelectorAll("tr"));

    const currentDir = th.dataset.sortDir;
    const dir = currentDir === "asc" ? "desc" : "asc";

    this.element.querySelectorAll("th[data-sort-dir]").forEach((h) => {
      delete h.dataset.sortDir;
      const arrow = h.querySelector(".sort-arrow");
      if (arrow) arrow.textContent = "↕";
    });

    th.dataset.sortDir = dir;
    const arrow = th.querySelector(".sort-arrow");
    if (arrow) arrow.textContent = dir === "asc" ? "↑" : "↓";

    rows.sort((a, b) => {
      const aText = a.children[index]?.textContent.trim() || "";
      const bText = b.children[index]?.textContent.trim() || "";

      let aVal, bVal;
      if (type === "number") {
        aVal = parseFloat(aText.replace(/[$,]/g, "")) || 0;
        bVal = parseFloat(bText.replace(/[$,]/g, "")) || 0;
      } else if (type === "date") {
        aVal = new Date(aText);
        bVal = new Date(bText);
      } else {
        aVal = aText.toLowerCase();
        bVal = bText.toLowerCase();
      }

      if (aVal < bVal) return dir === "asc" ? -1 : 1;
      if (aVal > bVal) return dir === "asc" ? 1 : -1;
      return 0;
    });

    rows.forEach((row) => this.bodyTarget.appendChild(row));
  }
}
